<template>
    <div>
      <!-- <h2> {{ this.results.company }} |  {{ this.results.contractType }} | {{ this.results.workTime }} | {{ this.results.locations }} </h2> -->
      <h2> {{ this.headerFields }} </h2>
    </div>
</template>
<script>

export default {

computed: {

    companySpecificConfig() { return this.$store.state.companySpecificConfig },  
    results() { return this.$store.state.results; },

    // recieves the selected companyConfiguration from vuex and reads the subheaderConfig array
    // 
    headerFields() {

        if (this.companySpecificConfig.subheaderConfig == undefined) { return '' }
        else {

        let finalString = ""
        let arrayCount = this.companySpecificConfig.subheaderConfig.length
        let iterationCount = 0


            this.companySpecificConfig.subheaderConfig.map( entry => {

                        // console.log(entry)


            if (entry == "company") {
                finalString += (this.results.company)
            }
            else if (entry == "contractType") {
                finalString += (this.results.contractType)
            }
            else if (entry == "workTime") {
                finalString += (this.results.workTime)
            }
            else if (entry == "locations") {
                finalString += (this.results.locations)
            }
            else if (entry == "workModel") {
                finalString += (this.results.workModel)
            }

            iterationCount += 1

            if (iterationCount != arrayCount) {
                finalString += ' | '
            } 
            })

            return finalString

                }
            }
        },
    }
</script>